import {useTranslation} from "react-i18next";
import React from "react";

const MaintenanceContent = () => {
    const { t } = useTranslation();

    return  <>
        <h1>{t("maintenance.title")}</h1>
        <p dangerouslySetInnerHTML={{ __html: t("maintenance.content") }} />
    </>;
};

export default MaintenanceContent;
